exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/work/internal-frontend/src/app/content-page/common/specializations/components/spec-warning/spec-warning.component.css
// module id = ../../../../../src/app/content-page/common/specializations/components/spec-warning/spec-warning.component.css
// module chunks = main